<template>
  <div class="search-results-section">
    <div class="title-container">
      <span class="title">{{ title }}</span>
      <slot v-if="isInline" />
      <button v-if="showClearButton" class="btn-clear" @click="$emit('clear')">
        {{ clearButtonText }}
      </button>
    </div>
    <slot v-if="!isInline" />
  </div>
</template>

<script>
export default {
  name: 'SearchResultsSection',

  props: {
    /**
     * Is section inline?
     *
     * @type {boolean}
     */
    isInline: {
      type: Boolean,
      default: false
    },
    /**
     * Section title
     *
     * @type {string}
     */
    title: {
      type: String,
      required: true
    },
    /**
     * Clear all button text
     *
     * @type {string}
     */
    clearButtonText: {
      type: String,
      default: 'Clear All'
    },
    /**
     * Show clear all button
     *
     * @type {boolean}
     */
    showClearButton: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.search-results-section {
  margin-bottom: 20px;
}

.title-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.title {
  color: #aaa;
  font-weight: 700;
}

.btn-clear {
  background-color: transparent;
  border: none;
  text-decoration: underline;

  &:hover {
    cursor: pointer;
  }
}
</style>
